import { geoGuides } from '@/data/geo-guides';

export interface BlogPostMeta {
  title: string;
  description: string;
  keywords: string;
  author: string;
  canonicalUrl: string;
  image?: string;
  datePublished?: string;
  dateModified?: string;
  extraSchemas?: unknown[];
}

export const blogPostMeta: Record<string, BlogPostMeta> = {
  ...Object.fromEntries(geoGuides.map(guide => [guide.slug, {
    title: `${guide.title} | SEOEVOLUTION`,
    description: guide.description,
    keywords: 'SEO con IA, GEO, visibilidad en IA, estrategia SEO empresarial',
    author: 'Ángel Ruz',
    canonicalUrl: `https://agenciaseoevolution.com/blog/${guide.slug}`,
    datePublished: '2026-11-05',
    dateModified: '2026-11-05',
  }])),
  "futuro-seo-local-2025": {
    title: "El futuro del SEO Local en 2025 | SEOEVOLUTION",
    description:
      "Descubre las últimas tendencias y estrategias para dominar el SEO local y Google Maps en 2025. Una guía completa para mejorar tu visibilidad local.",
    keywords:
      "SEO local, Google Maps, estrategias SEO 2025, posicionamiento local, visibilidad online",
    author: "Ángel Ruz",
    canonicalUrl: "https://agenciaseoevolution.com/blog/futuro-seo-local-2025",
    datePublished: "2025-04-22",
  },
  "categorias-fichas-producto-ecommerce": {
    title:
      "Categorías y fichas de producto perfectas: el secreto SEO de los eCommerce más exitosos en España",
    description:
      "Descubre cómo optimizar las fichas de producto de tu eCommerce para mejorar el SEO y aumentar las conversiones. Guía completa con ejemplos y casos de éxito.",
    keywords:
      "SEO eCommerce, fichas de producto, optimización SEO, categorías eCommerce, conversión ventas",
    author: "Ángel Ruz",
    canonicalUrl:
      "https://agenciaseoevolution.com/blog/categorias-fichas-producto-ecommerce",
    datePublished: "2025-04-22",
  },
  "seo-inteligente-ia": {
    title: "SEO Inteligente: Cómo la IA acelera tu posicionamiento | SEOEVOLUTION",
    description:
      "Descubre cómo la inteligencia artificial está transformando el SEO y mejorando el posicionamiento en Google. Aprende las últimas estrategias de IA para potenciar tus ventas.",
    keywords:
      "SEO inteligente, IA SEO, posicionamiento web, inteligencia artificial SEO, optimización web IA",
    author: "Ángel Ruz",
    canonicalUrl: "https://agenciaseoevolution.com/blog/seo-inteligente-ia",
    datePublished: "2025-04-26",
  },
  "seo-react-claves-optimizacion": {
    title:
      "El SEO de una página web en React: Claves para una optimización efectiva | SEOEVOLUTION",
    description:
      "Descubre las mejores prácticas y estrategias para optimizar el SEO en tus aplicaciones React. Aprende sobre renderizado, contenido y experiencia de usuario.",
    keywords:
      "SEO React, optimización web React, React SEO, posicionamiento React, renderizado SEO, estrategias SEO React",
    author: "Ángel Ruz",
    canonicalUrl:
      "https://agenciaseoevolution.com/blog/seo-react-claves-optimizacion",
    datePublished: "2025-05-03",
  },
  "inteligencia-artificial-negocios": {
    title:
      "Aprovecha la inteligencia artificial: Clave para el éxito de tu negocio | SEOEVOLUTION",
    description:
      "Descubre cómo implementar la inteligencia artificial en tu empresa para mejorar la eficiencia, personalizar la experiencia del cliente y potenciar tu crecimiento empresarial.",
    keywords:
      "inteligencia artificial negocios, IA empresas, implementación IA, ventajas inteligencia artificial, automatización empresarial, IA marketing, innovación empresarial",
    author: "Ángel Ruz",
    canonicalUrl:
      "https://agenciaseoevolution.com/blog/inteligencia-artificial-negocios",
    datePublished: "2025-05-10",
  },
  "marketing-digital-pequenas-empresas": {
    title:
      "Estrategias de Marketing Digital para Pequeñas Empresas: Guía Completa 2025 | SEOEVOLUTION",
    description:
      "Descubre las mejores estrategias de marketing digital para pequeñas empresas: SEO, redes sociales, email marketing, publicidad online y Google My Business. Guía práctica con ejemplos.",
    keywords:
      "marketing digital pequeñas empresas, estrategias marketing digital pymes, SEO para negocios locales, email marketing efectivo, publicidad digital pequeñas empresas, marketing de contenido pymes, redes sociales para pymes, Google My Business optimización",
    author: "Ángel Ruz",
    canonicalUrl:
      "https://agenciaseoevolution.com/blog/marketing-digital-pequenas-empresas",
    datePublished: "2025-02-15",
  },
  "vibe-coding-2026": {
    title:
      "Qué es el Vibe Coding y por qué está cambiando las reglas del juego en 2026 | SEOEVOLUTION",
    description:
      "Qué es el vibe coding, cómo funciona en 2026, las mejores herramientas y cómo combinarlo con SEO para lanzar productos digitales posicionados desde el primer día.",
    keywords:
      "vibe coding, inteligencia artificial, Lovable, desarrollo sin código, SEO técnico, herramientas IA, no-code 2026",
    author: "Ángel Ruz",
    canonicalUrl: "https://agenciaseoevolution.com/blog/vibe-coding-2026",
    datePublished: "2026-03-28",
  },
  "google-ai-overviews-seo-2026": {
    title:
      "Google AI Overviews: Impacto en el SEO y cómo adaptarse en 2026 | SEOEVOLUTION",
    description:
      "Descubre cómo los AI Overviews de Google están redistribuyendo el tráfico orgánico en 2026, qué sectores son los más afectados y las estrategias clave para ser citado por la IA.",
    keywords:
      "AI Overviews, Google IA, SEO 2026, GEO, optimización motores generativos, tráfico orgánico, citaciones IA",
    author: "Ángel Ruz",
    canonicalUrl:
      "https://agenciaseoevolution.com/blog/google-ai-overviews-seo-2026",
    image: "https://agenciaseoevolution.com/blog-ai-overviews-seo.jpg",
    datePublished: "2026-04-11",
    dateModified: "2026-04-11",
    extraSchemas: [
      {
        "@context": "https://schema.org",
        "@type": "Article",
        headline:
          "Google AI Overviews: Impacto en el SEO y cómo adaptarse en 2026",
        description:
          "Descubre cómo los AI Overviews de Google están redistribuyendo el tráfico orgánico en 2026, qué sectores son los más afectados y las estrategias clave para ser citado por la IA.",
        image: "https://agenciaseoevolution.com/blog-ai-overviews-seo.jpg",
        author: {
          "@type": "Person",
          name: "Ángel Ruz",
          url: "https://agenciaseoevolution.com/sobre-nosotros",
        },
        publisher: {
          "@type": "Organization",
          name: "SEOEVOLUTION",
          url: "https://agenciaseoevolution.com",
          logo: {
            "@type": "ImageObject",
            url: "https://agenciaseoevolution.com/logo.png",
          },
        },
        datePublished: "2026-04-11",
        dateModified: "2026-04-11",
        mainEntityOfPage:
          "https://agenciaseoevolution.com/blog/google-ai-overviews-seo-2026",
        inLanguage: "es",
        keywords:
          "AI Overviews, Google IA, SEO 2026, GEO, optimización motores generativos, tráfico orgánico",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "¿Qué son los AI Overviews de Google?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Los AI Overviews son resúmenes generados por inteligencia artificial que aparecen en la parte superior de los resultados de Google. Sintetizan información de múltiples fuentes web y presentan respuestas conversacionales antes de los enlaces tradicionales. En 2026, aparecen en el 30-35% de las búsquedas.",
            },
          },
          {
            "@type": "Question",
            name: "¿Cómo afectan los AI Overviews al tráfico orgánico?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Los AI Overviews redistribuyen el tráfico: las fuentes citadas ganan un 20-40% más de clics (CTR), mientras que las páginas en posiciones 3-10 no citadas pierden entre un 15-25% de tráfico orgánico. Las posiciones 1-2 se mantienen relativamente estables.",
            },
          },
          {
            "@type": "Question",
            name: "¿Qué es el GEO (Generative Engine Optimization)?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "El GEO es la optimización para motores generativos: la disciplina de preparar tu contenido para ser seleccionado, citado y recomendado por motores de búsqueda basados en IA como Google AI Overviews, ChatGPT y Perplexity. Se construye sobre los fundamentos del SEO añadiendo estructura semántica y credibilidad verificable.",
            },
          },
          {
            "@type": "Question",
            name: "¿Qué sectores son los más afectados por los AI Overviews?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Salud y medicina son los más afectados (45-50% de búsquedas muestran AI Overviews), seguidos de tecnología (35-40%) y finanzas (30-35%). Los negocios locales son los menos impactados (10-15%) ya que el Local Pack mantiene su protagonismo.",
            },
          },
        ],
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Inicio",
            item: "https://agenciaseoevolution.com",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Blog",
            item: "https://agenciaseoevolution.com/blog",
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Google AI Overviews: Impacto en el SEO 2026",
            item: "https://agenciaseoevolution.com/blog/google-ai-overviews-seo-2026",
          },
        ],
      },
    ],
  },
  "tendencias-seo-2026": {
    title:
      "Tendencias SEO 2026: Guía para dominar el nuevo ecosistema de búsqueda con IA | SEOEVOLUTION",
    description:
      "Las 7 tendencias SEO clave en 2026: búsqueda conversacional, E-E-A-T, contenido para IA, SEO local y checklist de acción. Guía completa para adaptar tu estrategia.",
    keywords:
      "tendencias SEO 2026, SEO con IA, GEO optimización, E-E-A-T, búsqueda conversacional, SEO local, Core Web Vitals",
    author: "Ángel Ruz",
    canonicalUrl: "https://agenciaseoevolution.com/blog/tendencias-seo-2026",
    image: "https://agenciaseoevolution.com/blog-tendencias-seo-2026.jpg",
    datePublished: "2026-04-11",
    dateModified: "2026-04-11",
    extraSchemas: [
      {
        "@context": "https://schema.org",
        "@type": "Article",
        headline:
          "Tendencias SEO 2026: Guía completa para dominar el nuevo ecosistema de búsqueda con IA",
        description:
          "Las 7 tendencias SEO clave en 2026: búsqueda conversacional, E-E-A-T, contenido para IA, SEO local y checklist de acción. Guía completa para adaptar tu estrategia.",
        image: "https://agenciaseoevolution.com/blog-tendencias-seo-2026.jpg",
        author: {
          "@type": "Person",
          name: "Ángel Ruz",
          url: "https://agenciaseoevolution.com/sobre-nosotros",
        },
        publisher: {
          "@type": "Organization",
          name: "SEOEVOLUTION",
          url: "https://agenciaseoevolution.com",
          logo: {
            "@type": "ImageObject",
            url: "https://agenciaseoevolution.com/logo.png",
          },
        },
        datePublished: "2026-04-11",
        dateModified: "2026-04-11",
        mainEntityOfPage:
          "https://agenciaseoevolution.com/blog/tendencias-seo-2026",
        inLanguage: "es",
        keywords:
          "tendencias SEO 2026, SEO con IA, GEO, E-E-A-T, búsqueda conversacional, SEO local, Core Web Vitals",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "¿Cuáles son las principales tendencias SEO en 2026?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Las 7 tendencias clave son: búsqueda conversacional y por voz, optimización técnica y UX (Core Web Vitals), autoridad de marca y E-E-A-T, contenido semántico listo para IA, contenido multimodal (texto, vídeo, audio), SEO local y personalización contextual, y automatización con equilibrio IA + humano.",
            },
          },
          {
            "@type": "Question",
            name: "¿Qué es el GEO (Generative Engine Optimization)?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "El GEO es la optimización para motores generativos: contenido estructurado, claro y semántico, pensado para que un agente inteligente lo lea y lo cite. Complementa al SEO tradicional y es esencial para aparecer en AI Overviews, ChatGPT, Perplexity y otros buscadores de IA.",
            },
          },
          {
            "@type": "Question",
            name: "¿Ha muerto el SEO en 2026?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "No, el SEO no ha muerto. Ha evolucionado. En 2026, el SEO deja de ser solo cuestión de rankings para convertirse en visibilidad inteligente: posicionarte en resultados tradicionales Y ser citado en respuestas de IA. Los fundamentos técnicos siguen siendo la base.",
            },
          },
          {
            "@type": "Question",
            name: "¿Cómo afecta el E-E-A-T al SEO en 2026?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "E-E-A-T (Experiencia, Expertise, Autoridad, Confiabilidad) es ahora el criterio principal que usan los modelos de IA para decidir qué fuentes citar. Demostrar experiencia real con casos de éxito, autoría visible, credenciales y datos verificables es más importante que nunca.",
            },
          },
          {
            "@type": "Question",
            name: "¿Qué tipo de contenido funciona mejor para SEO en 2026?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Funcionan mejor los checklists accionables, guías de decisión, comparativas reales con pros y contras, errores comunes con soluciones, y pasos ordenados. El contenido genérico que podría estar en cualquier web pierde relevancia frente al contenido diferenciado con experiencia real.",
            },
          },
        ],
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Inicio",
            item: "https://agenciaseoevolution.com",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Blog",
            item: "https://agenciaseoevolution.com/blog",
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Tendencias SEO 2026",
            item: "https://agenciaseoevolution.com/blog/tendencias-seo-2026",
          },
        ],
      },
    ],
  },
  "novedades-ia-mayo-2026": {
    title: "Novedades IA mayo 2026: GPT-5.5, iOS 27 con Claude y Gemini | SEOEVOLUTION",
    description:
      "Análisis de las novedades de la IA en mayo 2026: GPT-5.5, Apple abre iOS 27 a Claude y Gemini, memoria portable y qué implica para empresas y SEO.",
    keywords:
      "GPT-5.5, OpenAI, Claude, Gemini, Apple Intelligence, iOS 27, novedades IA 2026, GEO, agentes IA",
    author: "Ángel Ruz",
    canonicalUrl: "https://agenciaseoevolution.com/blog/novedades-ia-mayo-2026",
    image: "https://agenciaseoevolution.com/blog-novedades-ia-mayo-2026.jpg",
    datePublished: "2026-05-08",
    dateModified: "2026-05-08",
    extraSchemas: [
      {
        "@context": "https://schema.org",
        "@type": "Article",
        headline:
          "Novedades de la IA en mayo 2026: GPT-5.5, Apple abre iOS 27 a Claude y Gemini",
        description:
          "Análisis de las grandes novedades de la inteligencia artificial en mayo de 2026: el lanzamiento de GPT-5.5, la apertura de iOS 27 a Claude y Gemini, la memoria portable de Gemini y qué implica todo esto para empresas y SEO.",
        image: "https://agenciaseoevolution.com/blog-novedades-ia-mayo-2026.jpg",
        author: {
          "@type": "Person",
          name: "Ángel Ruz",
          url: "https://agenciaseoevolution.com/sobre-nosotros",
        },
        publisher: {
          "@type": "Organization",
          name: "SEOEVOLUTION",
          url: "https://agenciaseoevolution.com",
          logo: {
            "@type": "ImageObject",
            url: "https://agenciaseoevolution.com/logo.png",
          },
        },
        datePublished: "2026-05-08",
        dateModified: "2026-05-08",
        mainEntityOfPage:
          "https://agenciaseoevolution.com/blog/novedades-ia-mayo-2026",
        inLanguage: "es",
        keywords:
          "GPT-5.5, OpenAI, Claude, Gemini, Apple Intelligence, iOS 27, novedades IA 2026, GEO",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "¿Qué novedades trae GPT-5.5 frente a GPT-5?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "GPT-5.5, lanzado el 23 de abril de 2026, mejora el razonamiento agéntico, reduce las alucinaciones entre un 30 y un 40 % y ejecuta tareas complejas de varios pasos con mínima intervención humana. Su versión Pro se enfoca en informes, auditorías y código profesional.",
            },
          },
          {
            "@type": "Question",
            name: "¿Cómo funcionará la elección de IA en iOS 27?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Desde Ajustes, el usuario podrá elegir entre el modelo propio de Apple, ChatGPT, Claude o Gemini para ejecutar las funciones de Apple Intelligence. Apple actuará como orquestador neutral, manteniendo el cifrado y aprovechando Private Cloud Compute cuando sea posible.",
            },
          },
          {
            "@type": "Question",
            name: "¿Qué es la memoria portable de Gemini?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Es una nueva funcionalidad que permite importar a Gemini todo el contexto que ChatGPT o Claude tienen del usuario: preferencias, proyectos, tono de escritura y memoria de largo plazo. Marca el inicio de la portabilidad real entre proveedores de IA.",
            },
          },
          {
            "@type": "Question",
            name: "¿Cómo afectan estas novedades al SEO de mi web?",
            acceptedAnswer: {
              "@type": "Answer",
              text: "Cada vez más consultas se resuelven dentro de asistentes (ChatGPT, Claude, Gemini, Apple Intelligence) sin abrir el navegador. La estrategia ganadora es el GEO (Generative Engine Optimization): contenido estructurado, schema markup, autoridad temática y datos verificables para ser citado por todos los modelos.",
            },
          },
        ],
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Inicio",
            item: "https://agenciaseoevolution.com",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Blog",
            item: "https://agenciaseoevolution.com/blog",
          },
          {
            "@type": "ListItem",
            position: 3,
            name: "Novedades de la IA en mayo 2026",
            item: "https://agenciaseoevolution.com/blog/novedades-ia-mayo-2026",
          },
        ],
      },
    ],
  },
};
